import request from '@/utils/request'

/**
 * 任务中心-到店核销相关接口
 * 后端 Controller: TaskCenterFrontController
 * 基础路径: /taskcenter/front
 * 核销码前缀: JDREDD（任务到店），与积分兑换核销码 JDPV 区分
 */

/**
 * 核销信息（用户 + 任务 + 本店是否支持核销 + 二维码）
 * @param {String} code 任务到店核销码（JDREDD 开头）
 */
export function taskVerifyInfo(code) {
  return request({
    url: '/taskcenter/front/verifyInfo',
    method: 'get',
    params: { code }
  })
}

/**
 * 核销（一次性核销，无数量概念，成功后自动发放任务奖励）
 * @param {String} code 任务到店核销码（JDREDD 开头）
 */
export function taskVerifyTask(code) {
  return request({
    url: '/taskcenter/front/verifyTask',
    method: 'post',
    data: { code }
  })
}

/**
 * 查看/生成门店任务二维码（用户到店扫码核销用，二维码内容=yml任务二维码路由+storeId）
 * @param {Number} businessId 门店账号id
 */
export function selectTaskQrById(businessId) {
  return request({
    url: '/agent/user/selectTaskQrById',
    method: 'get',
    params: { businessId }
  })
}
